import { createTransform } from 'redux-persist'
import { CompanyCardsState, initialState } from './companyCardsSlice'
import { RootState } from '../../types/RootState'

export const transformer = createTransform<
  CompanyCardsState,
  Omit<CompanyCardsState, 'error'>,
  RootState
>(
  inboundState => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { error, ...persistedState } = inboundState
    return persistedState
  },
  outboundState => {
    const status: CompanyCardsState['status'] =
      outboundState.status === 'initial' ? outboundState.status : 'idle'
    return {
      ...outboundState,
      error: initialState.error,
      status,
    }
  },
  {
    whitelist: ['companyCards'],
  },
)
